/* eslint-disable global-require */
import conf from 'conf'
// import i18n from 'i18n'

import appTypeConfigFunc from 'apptype-config'

export default async function getMenuData() {
  const appTypeConfig = appTypeConfigFunc()
  const menuList = appTypeConfig.menu()

  if (conf.DEBUG === true) {
    menuList.push({
      title: 'Settings',
      key: 'settings',
      icon: 'fe fe-settings utils__spin-delayed--pseudo-selector',
    })
  }

  return menuList
}
